import { openDB } from 'idb';
let owner: string | null = null;
let epoch = 0;
const dbPromise = typeof window === 'undefined' ? null : openDB('novari-offline-db', 3, {
  upgrade(db, version, _next, tx) {
    for (const name of ['flashcards', 'documents']) {
      if (!db.objectStoreNames.contains(name)) db.createObjectStore(name, { keyPath: 'id' });
      else if (version < 3) void tx.objectStore(name).clear();
    }
  },
});
let cleanup: Promise<void> = Promise.resolve();
export function setOfflineUser(userId: string | null): Promise<void> {
  if (owner === userId && userId !== null) return cleanup;
  const clearExisting = owner !== null || userId === null;
  owner = userId; epoch++;
  cleanup = cleanup.catch(() => {}).then(async () => {
    const db = await dbPromise;
    if (db && clearExisting) {
      const tx = db.transaction(['flashcards', 'documents'], 'readwrite');
      await Promise.all([tx.objectStore('flashcards').clear(), tx.objectStore('documents').clear(), tx.done]);
    }
    if (typeof caches !== 'undefined') {
      for (const key of await caches.keys()) if (key.includes('supabase-api')) await caches.delete(key);
    }
  }).catch(error => { console.warn('Offline cleanup failed; cache disabled', error); owner = null; epoch++; });
  return cleanup;
}
async function read(store: string, id: string) {
  const scope = owner, generation = epoch;
  if (!scope) return null;
  await cleanup; const db = await dbPromise;
  if (!db || scope !== owner || generation !== epoch) return null;
  const value = await db.get(store, scope + ':' + id);
  return scope === owner && generation === epoch ? value : null;
}
async function write(store: string, id: string, value: object) {
  const scope = owner, generation = epoch;
  if (!scope) return;
  await cleanup; const db = await dbPromise;
  if (!db || scope !== owner || generation !== epoch) return;
  await db.put(store, { ...value, id: scope + ':' + id, timestamp: Date.now() });
}
export const offlineStorage = {
  async saveDeck(id: string, content: Record<string, unknown>) { await write('flashcards', id, { content }).catch(() => {}); },
  async getDeck(id: string) { return (await read('flashcards', id).catch(() => null))?.content ?? null; },
  async saveDocumentBlob(id: string, blob: Blob) { await write('documents', id, { blob }).catch(() => {}); },
  async getDocumentBlob(id: string): Promise<Blob | null> { return (await read('documents', id).catch(() => null))?.blob ?? null; },
};
